module.exports = __webpack_public_path__ + "static/engage_stakeholders-b40981140d74bd212f7588bcc765f19d.svg";